<div class="dialog-container">
  <div class="dialog-header flex_sb p-b-12">
    <div class="dialog-header-title">
     <div class="custom-timing fw-600"> {{'CUSTOM_TIMINGS.CUSTOM_TIMING' | translate}}  </div>
      <div class="custom-timing-desc fw-400 fs-14">{{'CUSTOM_TIMINGS.VIEW_YOUR_REPORT_BASED_ON_CUSTOM_TIMING' | translate}} </div>
    </div>
    <div class="dialog-header-cross" (click)="cancelClicked()">
      <img [src]="images.CROSS" class="img-20" alt="close"/>
    </div>
  </div>
  <div class="dialog-form"  [formGroup]="customTimings" >
<div class="flex-align-center time-box-container">
  <div class="time-box">
    <div class="start-at fw-600 m-b-2">{{ 'CUSTOM_TIMINGS.START_TIME' | translate }}</div>
    <div class="input-time">
      <nz-time-picker
        formControlName="time1"
        [nzPlaceHolder]="'SELECT_TIME' | translate"
        [nzUse12Hours]="true"
        nzFormat="h:mm a"
        nzInputReadOnly="true"
      ></nz-time-picker>
    </div>
  </div>

  <div class="time-box">
    <div class="ends-at fw-600 fs-14 m-b-2">{{ 'CUSTOM_TIMINGS.END_TIME' | translate }}</div>
    <div class="input-time">
      <nz-time-picker
        formControlName="time2"
        [nzPlaceHolder]="'SELECT_TIME' | translate"
        [nzUse12Hours]="true"
        nzFormat="h:mm a"
        nzInputReadOnly="true"
      ></nz-time-picker>
    </div>
  </div>
  <div class="m-t-14 selected-day" *ngIf="isBothTimeSelected" translate>
    {{ isSameDay ? 'CUSTOM_TIMINGS.SAME_DAY' : 'CUSTOM_TIMINGS.NEXT_DAY' }}
  </div>
</div>
  </div>
  <div class="dialog-footer">
    <button class="btn-done color-white wd-100" (click)="setTime()" nz-button nzSize="large">
      {{ 'CUSTOM_TIMINGS.SET_TIME_FROM' | translate }}
      {{ showOnlyTime(customTimings?.get('time1')?.value) }}
      {{ 'CUSTOM_TIMINGS.SAME_DAY' | translate }}
      {{ 'CUSTOM_TIMINGS.TO' | translate }}
      {{ showOnlyTime(customTimings?.get('time2')?.value) }}
      <ng-container *ngIf="isBothTimeSelected">
        <span translate>{{ isSameDay ? 'CUSTOM_TIMINGS.SAME_DAY' : 'CUSTOM_TIMINGS.NEXT_DAY' }}</span>
      </ng-container>
    </button>
  </div>
</div>
